import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BunnyVideoPlayer } from 'components/BunnyMediaRenderer';
import { Button } from 'components/Button';
import { useStore, useTask } from 'engine/store';
import { ChevronRight } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/fullscreen-video/$roundId/$taskId')({
	component: RouteComponent,
	// TODO: maybe redirect back to task screen if task is not of task type fullscreen video
});

function RouteComponent() {
	const params = Route.useParams();
	const navigate = useNavigate();
	const t = useTask(params.roundId, params.taskId);
	const submitTaskSubmission = useStore((s) => s.submitTaskSubmission);

	if (t.task?.type !== 'fullscreen-video') {
		throw new Error('Task is not of type fullscreen-video');
	}
	const media = t.task.media;
	if (!media) {
		throw new Error('Task has no media');
	}
	if (media.kind !== 'video') {
		throw new Error('Task media is not a video');
	}

	// const [isPlaying, setIsPlaying] = useState(true);

	const [submitted, setSubmitted] = useState(false);

	// const _donePlaying = !isPlaying;

	return (
		<div className="relative size-full">
			{
				/*donePlaying &&*/ <div className="absolute right-4 top-20 z-20 flex">
					<Button
						onClick={() => {
							if (submitted) return;

							setSubmitted(true);
							console.log('continue...');
							submitTaskSubmission({
								taskId: params.taskId,
								answer: { kind: 'text', text: 'video-watched' },
								status: 'done',

								// unused fields
								attempts: 1,
								unlocked: true,
								pointsGiven: 0,
							});

							// NOTE: we only do this after setting the task to in-progress otherwise we would get a navigation loop!
							navigate({
								to: '/current-task',
							});
						}}
					>
						Continue <ChevronRight />
					</Button>
				</div>
			}
			<BunnyVideoPlayer
				fullScreen
				videoId={media.videoId}
				autoplay={t.task.autoplayMedia}
				showSpeed={false}
				playsinline={true}
				disableIosPlayer={true}
				// onPlay={() => {
				// 	console.log('video started.');
				// 	setIsPlaying(true);
				// }}
				// onEnded={() => {
				// 	console.log('video ended.');
				// 	setIsPlaying(false);
				// }}
			/>
		</div>
	);
}
